import { Box, Divider } from "@mui/material";
import { MetricBox } from "./metrics_box";
import { KPICards } from "./kpi_cards";
import { AlertsSection } from "./alerts_section";
import { PerformanceChart } from "./performance_chart";
import { InventoryChart } from "./inventory_chart";
import { KPICollection, Alerts, TrendData } from "./types";
// import { useState } from "react";

export type MetricDetails = {
  current_value: number;
  percentage_change: number;
};

export const RunDetailsComponent = (props: {
  loading: boolean;
  currentYearRevenueDetails: MetricDetails | null;
  currentYearPurchasesDetails: MetricDetails | null;
  maxInventoryOnHandDetails: MetricDetails | null;
  summaryText: string;
  origName: string | null;
  saveName: (name: string) => void;
  origDescription: string | null;
  saveDescription: (description: string) => void;
  kpis: KPICollection | null;
  alerts: Alerts | null;
  trendData: TrendData | null;
}) => {
  const {
    loading,
    currentYearRevenueDetails,
    currentYearPurchasesDetails,
    maxInventoryOnHandDetails,
    summaryText,
    kpis,
    alerts,
    trendData,
    // origName,
    // saveName,
    // origDescription,
    // saveDescription,
  } = props;

  // Determine if we have enhanced data
  const hasEnhancedData = kpis !== null;

  // const [name, setName] = useState<string>(origName || "");
  // const [description, setDescription] = useState<string>(origDescription || "");

  return (
    !loading && (
      <>
        {/* Show enhanced dashboard if available, otherwise show legacy view */}
        {hasEnhancedData && kpis ? (
          <>
            {/* Enhanced KPI Cards */}
            <KPICards kpis={kpis} />

            {/* AI Summary */}
            <Box
              sx={{
                mt: 2,
                mb: 3,
                p: 2.5,
                backgroundColor: "action.hover",
                borderRadius: 1,
                whiteSpace: "normal",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                fontSize: 14,
                lineHeight: 1.6,
              }}
            >
              {summaryText}
            </Box>

            {/* Alerts Section */}
            {alerts && <AlertsSection alerts={alerts} />}

            <Divider sx={{ my: 4 }} />

            {/* Performance Trends Chart */}
            {trendData && <PerformanceChart trendData={trendData} />}

            {/* Inventory Health Chart */}
            {trendData && <InventoryChart trendData={trendData} />}
          </>
        ) : (
          <>
            {/* Legacy View (backward compatibility) */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                pt: 1,
                opactity: loading ? 0 : 1,
              }}
            >
              {currentYearRevenueDetails && (
                <MetricBox
                  title="Current Year Revenue"
                  value={currentYearRevenueDetails.current_value}
                  change={currentYearRevenueDetails.percentage_change}
                />
              )}
              {currentYearPurchasesDetails && (
                <MetricBox
                  title="Current Year Purchases"
                  value={currentYearPurchasesDetails.current_value}
                  change={currentYearPurchasesDetails.percentage_change}
                />
              )}
              {maxInventoryOnHandDetails && (
                <MetricBox
                  title="Max Inventory on Hand"
                  value={maxInventoryOnHandDetails.current_value}
                  change={maxInventoryOnHandDetails.percentage_change}
                />
              )}
            </Box>
            <Box
              sx={{
                mt: 1,
                p: 1,
                backgroundColor: "action.hover",
                borderRadius: 1,
                whiteSpace: "normal",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {summaryText}
            </Box>
          </>
        )}
      </>
    )
  );
};
